import React, { useState, useEffect } from "react";
import "./Auth-Layout.scss";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Logo from "../../resources/logo.png";
import roomImg1 from "../assets/images/room-image.jpeg";
import roomImg2 from "../assets/images/room-image2.jpeg";
import roomImg3 from "../assets/images/room-image3.jpeg";

const images = [roomImg1, roomImg2, roomImg3];

const AuthLayout = ({
  children,
  title,
  subtitle,
  subtitleLinkText,
  subtitleLinkTo,
  onSubtitleAction,
}) => {
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const subtitleAction = subtitleLinkText && (
    onSubtitleAction ? (
      <button type="button" className="header-action-link" onClick={onSubtitleAction}>
        {subtitleLinkText}
      </button>
    ) : subtitleLinkTo ? (
      <Link to={subtitleLinkTo} className="header-action-link">
        {subtitleLinkText}
      </Link>
    ) : null
  );

  // Subtle rotation of background images
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveImageIndex((prev) => (prev + 1) % images.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="auth-layout-container">
      {/* Left Branded Hero Panel */}
      <div className="auth-left-panel">
        <div
          className="auth-image-bg"
          style={{ backgroundImage: `url(${images[activeImageIndex]})` }}
        />
        <div className="auth-overlay-gradient" />

        {/* Top Header */}
        <div className="auth-left-top-bar">
          <Link to="/" className="brand-badge">
            <img src={Logo} alt="RentlyBuzz logo" className="brand-logo-img" />
            <span className="brand-name">RentlyBuzz</span>
          </Link>

          <Link to="/" className="back-website-btn">
            <span>Back to website</span>
            <FiArrowRight className="btn-icon" />
          </Link>
        </div>

        {/* Bottom Tagline & Carousel Dots */}
        <div className="auth-left-bottom-content">
          <h2 className="tagline-heading">Simplifying Property Management</h2>
          <p className="tagline-subtext">
            Streamlined rental operations, automated billing, and effortless tenant communication all in one place.
          </p>

          <div className="carousel-dots-wrapper">
            {images.map((_, idx) => (
              <span
                key={idx}
                className={`carousel-dot ${
                  idx === activeImageIndex ? "active" : ""
                }`}
                onClick={() => setActiveImageIndex(idx)}
                role="button"
                tabIndex={0}
                aria-label={`Slide ${idx + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Right Form Panel */}
      <div className="auth-right-panel">
        <div className="auth-form-card">
          {/* Header */}
          <div className="auth-form-header">
            {/* Mobile Logo inside form card */}
            <Link to="/" className="brand-badge mobile-form-logo">
              <img src={Logo} alt="RentlyBuzz logo" className="brand-logo-img" />
              <span className="brand-name">RentlyBuzz</span>
            </Link>

            {title && <h1 className="form-main-title">{title}</h1>}
            {subtitle && (
              <p className="form-subtitle desktop-subtitle">
                {subtitle}{" "}
                {subtitleAction}
              </p>
            )}
          </div>

          {/* Form Body */}
          <div className="auth-form-body">{children}</div>
          
          {/* Mobile Footer Subtitle */}
          {subtitle && (
            <div className="auth-form-footer mobile-subtitle">
              <p className="form-subtitle">
                {subtitle}{" "}
                {subtitleAction}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
